import styled from "styled-components";

export const OpTitle = styled.h1`
z-index:1;
width:100%;



/* max-width:1300px; */
padding-top:40px;
  margin-bottom: 24px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600;
  color:#8CA1A5;


@media screen and (max-width:991px) {
    padding-right: 30px;
    padding-left: 30px;
}

`

export const WrapperForReal = styled.div`
padding-top:80px;
text-align:center;




`

export const BigContainer = styled.div`
background:#f9F9F9;
border:1px solid red;`